module.exports = __webpack_public_path__ + "static/media/first-patient.d7e05d46.png";